import { Action } from 'redux';
import { ErrorWrapper } from 'store/base';

export const REDUCER_NAME__INVOICES = 'invoices';

export interface InvoiceListReduxState {
  type?: string;
  loading: boolean;
  errorWrapper?: ErrorWrapper;
}

const defaultState: InvoiceListReduxState = {
  loading: false,
};

export default (
  state: InvoiceListReduxState = defaultState,
  action: Action,
): InvoiceListReduxState => {
  return state;
};
